import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Icon, Modal } from 'semantic-ui-react';
import firebase from 'firebase/app';
import { useForm } from 'react-hook-form';
import { User } from '../../../models/user';
import { HFSelect } from 'libs/ui/src/lib/form/hf-select';
import { ROLES } from './options';
import { useUsers } from '../../../api/use-users';
import { HFInput } from 'libs/ui/src/lib/form/hf-input';

interface EditUserProps {
  onClose: () => void;
  user: User;
}

export function EditUserModal({ onClose, user }: EditUserProps) {
  const { t } = useTranslation();

  const { updateUser } = useUsers();

  const [companies, setCompanies] = useState([]);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: user });

  const onSubmit = async (data) => {
    await updateUser(user.uid, data);
    onClose();
  };

  useEffect(() => {
    const unsubscribe = firebase
      .firestore()
      .collection('companies')
      .onSnapshot((snapshot) => {
        const list = [];
        snapshot.forEach((doc) => {
          const { name } = doc.data();
          list.push({ key: doc.id, value: doc.id, text: name });
        });
        setCompanies(list);
      });
    return unsubscribe;
  }, []);

  return (
    <Modal dimmer={'inverted'} size="small" open onClose={onClose}>
      <Modal.Header>{t('users.editModalTitle')}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group widths="equal">
            <HFInput
              {...{
                name: 'name',
                label: t('users.name'),
                errors,
                control,
              }}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <HFSelect
              {...{
                multiple: true,
                name: 'roles',
                label: t('users.roles'),
                options: ROLES,
                required: true,
                errors,
                control,
              }}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <HFSelect
              {...{
                multiple: true,
                name: 'companies',
                label: t('users.companies'),
                options: companies,
                required: true,
                errors,
                control,
              }}
            />
          </Form.Group>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button positive onClick={handleSubmit(onSubmit)}>
          {t('users.edit')}
        </Button>
        <Button onClick={onClose}>{t('users.cancel')}</Button>
      </Modal.Actions>
    </Modal>
  );
}
